import { Activite } from './activite.model';
import { DataIdArrayConverterFactory } from 'src/app/core/services/mapper/data-id.converter';

export class Cahier {
    static jsonMap = {
        id: { key: 'id' },
        libelle: { key: 'libelle' },
        activites: { key: 'activites', converter: new (DataIdArrayConverterFactory.build(Activite, 'activites'))(), optional: true }
    };

    public id: number = undefined;
    public libelle: string = undefined;
    public activites: Activite[] = undefined;
}
